// extracted by mini-css-extract-plugin
export default {"container":"info_container__LiIae","box":"info_box__5XmLh","heading":"info_heading__QwPhl","text":"info_text__ZXpi-"};